<template>
  <comparison-graph :date-range="dateRange" :biz="biz" :top-performer="topPerformer" api-endpoint="response-times-breakdown"/>
</template>

<script>
  import ComparisonGraph from './ComparisonGraph'

  export default {
    name: 'ReplyCompare',
    components: {ComparisonGraph},
    props: {
      dateRange: {
        type: Object,
        required: true
      },
      biz: {
        type: Array,
        required: true
      },
      summary: {
        type: Array,
        required: true
      }
    },
    computed: {
      topPerformer () {
        let data = {name: '', score: ''}

        if (this.biz.length && this.summary.length) {
          let min = ''
          this.biz.forEach(b => {
            const biz = this.summary.find(summaryBiz => summaryBiz.business_id === b.id)
            if (biz) {
              if (!min) {
                min = biz
              } else if (biz.total_replies && Math.floor(biz.reply_time) < Math.floor(min.reply_time)) {
                min = biz
              }
            }
          })

          if (min) {
            data.name = min.name
            data.score = min.reply_time
          }
        }

        return data
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/analytics/competitors/ReplyCompare.vue